import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function initializeSolutionsCarouselBlock(root) {
    if (!root || root.dataset.solutionsCarouselInitialized === 'true') {
        return;
    }

    const swiperContainer = root.querySelector('.swiper');

    if (!swiperContainer) {
        return;
    }

    root.dataset.solutionsCarouselInitialized = 'true';

    new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 20,
        modules: [Navigation],
        navigation: {
            nextEl: root.querySelector('.swiper-button-next'),
            prevEl: root.querySelector('.swiper-button-prev')
        }
    });
}

function initializeFrontend() {
    document.querySelectorAll('.solutions-carousel').forEach(initializeSolutionsCarouselBlock);
}

if (window.acf) {
    window.acf.addAction('render_block_preview/type=solutions-carousel', ($block) => {
        initializeSolutionsCarouselBlock($block.get(0));
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFrontend);
} else {
    initializeFrontend();
}